export default __webpack_public_path__ + "static/media/cart.448438cd.svg";